import { FilterConfiguration } from './types';
import { FilterCodeHierarchy } from './filter-code-hierarchy';
import { FilterCheckbox } from './filter-checkbox';
import { FilterInput } from './filter-input';
import { withFilterValidation } from './validators/filter-validation';
import { FilterDateRange } from './filter-date-range';
import { FilterDate } from './filter-date';
import { intValidate } from './validators/number-validator';
import { FilterDateSpecificPeriod } from 'app/area/search-filters/filters/filter-date-specific-period';
import { FilterDecimalRange } from 'app/area/search-filters/filters/filter-decimal';
import { FilterCodeSingle } from 'app/area/search-filters/filters/filter-code-single';
import { FilterDefaultValueMultiple } from 'app/area/search-filters/filters/filter-default-value-multiple';
import { FilterDefaultValueSingleHierarchy as FilterDefaultValueSingleHierarchy } from 'app/area/search-filters/filters/filter-default-value-single-hierarchy';
import { FilterCodeHierarchyWithCategory } from 'app/area/search-filters/filters/filter-code-hierarchy-with-category';

export const inputIntegerFilter: FilterConfiguration<string> = {
  component: withFilterValidation(intValidate)(FilterInput),
  menuOptions: {
    clear: true,
    excludeInclude: true
  }
};

export const inputIntegerWithoutExcludeFilter: FilterConfiguration<string> = {
  component: withFilterValidation(intValidate)(FilterInput),
  menuOptions: {
    clear: true
  }
};

export const dateFilter: FilterConfiguration<Date> = {
  component: FilterDate,
  menuOptions: {
    clear: true,
    excludeInclude: true
  }
};

export const dateRangeFilter: FilterConfiguration<Date> = {
  component: FilterDateRange,
  menuOptions: {
    clear: true,
    excludeInclude: true
  }
};

export const dateSpecificPeriodFilter: FilterConfiguration<Date> = {
  component: FilterDateSpecificPeriod,
  menuOptions: {
    clear: true,
    excludeInclude: true
  }
};

export const codeFilter: FilterConfiguration<string> = {
  component: FilterCodeHierarchy,
  menuOptions: {
    clear: true,
    excludeInclude: true
  }
};

export const codeWithoutExcludeFilter: FilterConfiguration<string> = {
  component: FilterCodeHierarchy,
  menuOptions: {
    clear: true
  }
};

export const codeHierarchyFilter: FilterConfiguration<string> = {
  component: FilterCodeHierarchy,
  menuOptions: {
    clear: true,
    excludeInclude: true,
    excludeIncludeChildren: true
  }
};

export const codeHierarchySubLevelFilter: FilterConfiguration<string> = {
  component: FilterCodeHierarchy,
  menuOptions: {
    clear: true,
    excludeIncludeChildren: true
  }
};

export const codeHierarchySubLevelWithCategory: FilterConfiguration<string> = {
  component: FilterCodeHierarchyWithCategory,
  menuOptions: {
    clear: true,
    excludeIncludeChildren: true
  }
};

export const codeHierarchyParentsFilter: FilterConfiguration<string> = {
  component: FilterCodeHierarchy,
  menuOptions: {
    clear: true,
    excludeInclude: true,
    excludeIncludeParents: true
  }
};

export const checkboxFilter: FilterConfiguration<number> = {
  component: FilterCheckbox,
  menuOptions: {}
};

export const textFilter: FilterConfiguration<string> = {
  component: FilterInput,
  menuOptions: {
    clear: true
  }
};

export const decimalRangeFilter: FilterConfiguration<number> = {
  component: FilterDecimalRange,
  menuOptions: {
    clear: true,
    excludeInclude: true
  }
};

export const codeSingleFilter: FilterConfiguration<number> = {
  component: FilterCodeSingle,
  menuOptions: {
    clear: true
  }
};

export const defaultValueSingleHierarchy: FilterConfiguration<number> = {
  component: FilterDefaultValueSingleHierarchy,
  menuOptions: {}
};

export const defaultValueMultipleFilter: FilterConfiguration<string> = {
  component: FilterDefaultValueMultiple,
  menuOptions: {}
};
